import { React} from 'react'
import { motion } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { Card, CardBody } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../CustomerPortal.css';
import { UserDetailsChange } from './UserDetailsChange';


const UserDetails = ({formik,setSelectedService,selectedData ,UserDetailAlt,policy_number,req_count}) => {
     // Names of the Changes and Icons in User Details Menu
    //  const UserDetailsChange = [
    //     {
    //         name: "Name Change",
    //         setSelcted: 7,

    //     },
    //     {
    //         name: "Address change",
    //         setSelcted: 8,

    //     },
    //     {
    //         name: "Add or Correct NIC Numbers",
    //         setSelcted: 9
    //     },
    //     {
    //         name: "Add, Change or Remove Contact No",
    //         setSelcted: 10
    //     },


    // ]

 
  return (
    <>

    <motion.div
        style={{ width: "100%" }}
        initial={{

            opacity: 0
        }}
        animate={{

            opacity: 1,
            transition: { duration: 0.3 }
        }}
    >
        <Row style={{margin:0}}>

            <Col xs={1} className='my-3'>
                <motion.div
                    whileTap={{
                        scale: 0.9
                    }}
                    onClick={() => { setSelectedService(0) }}
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                </motion.div>
            </Col>

        </Row>
        <Row style={{ width: "100%",margin:0 }} className='d-flex justify-content-center align-items-center'>
            <Col xs={12}>
                <Row>
                    {/* {
                        UserDetailsChange.map((value, index) => {


                            return (
                                <Col xs={6}>
                                    <motion.div
                                        initial={{
                                            y: "50%",
                                            opacity: 0
                                        }}
                                        animate={{
                                            y: "0%",
                                            opacity: 1,
                                            transition: { duration: 0.3, delay: (0.1 * index) }
                                        }}
                                        whileHover={{
                                            scale: 0.9,
                                            transition: { duration: 0.1 },
                                        }}

                                        onClick={() => { setSelectedService(value.setSelcted) }}
                                    >
                                        <Card className="py-4 my-4" style={{ width: "100%", height: "25vh" }}>

                                            <CardBody className="overflow-visible py-2 d-flex align-items-center justify-content-center" style={{ textAlign: "center" }}>

                                                <p style={{ fontSize: "1.1rem", width: "75%" }} >{value.name}</p>

                                            </CardBody>
                                        </Card>
                                    </motion.div>
                                </Col>
                            )

                        })
                    } */}
                  <UserDetailsChange req_count={req_count} formik={formik} selectedData={selectedData} policy_number={policy_number} UserDetailAlt={UserDetailAlt}/>
                </Row>

            </Col>

        </Row>
    </motion.div>
</>
  )
}

export default UserDetails
